import PGlobal from './PGlobal';

const NORMAL = 0;
const OVER = 1;
const DOWN = 2;
const DISABLE = 3;

export default class PButton extends PIXI.Sprite {
    constructor(textures) {
        super();
        if (textures) this.textures = textures;
        this.interactive = true;

        this.on("mousedown", (e) => this.onMouseDown(e));
        this.on("mouseup", (e) => this.onMouseUp(e));
        this.on("mouseover", (e) => this.onMouseOver(e));
        this.on("mouseout", (e) => this.onMouseOut(e));

        this.changeState(NORMAL);
    }

    changeState(state) {
        this.state = state;
        let texture = PGlobal.resources.mainUI.textures[this.textures[state]];
        this.texture = texture;
    }

    setTextures(textures){
        this.textures = textures;
        this.changeState(this.state);
    }

    set enable(b) {
        if(b) {
            this.changeState(NORMAL);
        }else {
            this.changeState(DISABLE);
        }
    }

    get enable() {
        return this.state != DISABLE;
    }

    disabled() {
        return this.state == DISABLE;
    }

    onMouseDown(e) {
        if(this.state != DISABLE) {
            this.changeState(DOWN);
        }
    }

    onMouseUp(e) {
        if(this.state != DISABLE) {
            this.changeState(OVER);
        }
    }

    onMouseOver(e) {
        if(this.state != DISABLE) {
            this.changeState(OVER);
        }
    }

    onMouseOut(e) {
        if(this.state != DISABLE) {
            this.changeState(NORMAL);
        }
    }
}



// WEBPACK FOOTER //
// ./src/common/scripts/pixi/PButton.js